import React, { Fragment } from 'react';
import SubscribeFrom from 'react-mailchimp-subscribe';
import { useStaticQuery, graphql } from 'gatsby';
import { MailchimpForm } from './form';

interface MailChimpProps {
  setSuccess?: (status: boolean) => void;
  backgroundTheme: 'light' | 'dark';
}

const Mailchimp: React.FC<MailChimpProps> = ({
  setSuccess,
  backgroundTheme,
}) => {
  const mailchimpData = useStaticQuery(graphql`
    query MailchimpTwoQuery {
      site {
        siteMetadata {
          mailchimp_endpoint
        }
      }
    }
  `);
  const url = mailchimpData.site.siteMetadata.mailchimp_endpoint;
  return (
    <Fragment>
      <SubscribeFrom
        url={url}
        render={({ subscribe, status, message }) => (
          <MailchimpForm
            status={status}
            message={message}
            setSuccess={setSuccess}
            onValidated={(formData) => subscribe(formData)}
            backgroundTheme={backgroundTheme}
          />
        )}
      />
    </Fragment>
  );
};

export default Mailchimp;
